import { useMemo } from 'react'
import { useProjectMenuStore } from '../zustand/project-menu/use-project-menu-store'
import {
  myProjectSortDirectionOptions,
  myProjectSortOptions
} from '../react-query/project/query/use-get-my-projects-query'

const defaultSorting = [{ id: myProjectSortOptions.LAST_MODIFIED, desc: true }]

export const useMyProjectsQueryParams = () => {
  const search = useProjectMenuStore((state) => state.projectMenuSearch)
  const size = useProjectMenuStore((state) => state.projectListPageSize)
  const page = useProjectMenuStore((state) => state.projectListPageNumber)
  const sorting = useProjectMenuStore(
    (state) => state.myProjectsSorting ?? defaultSorting
  )

  const [
    { id: projectSort = myProjectSortOptions.LAST_MODIFIED, desc = true } = {}
  ] = sorting

  const sortDirection = desc
    ? myProjectSortDirectionOptions.DESC
    : myProjectSortDirectionOptions.ASC

  return useMemo(
    () => ({ search, projectSort, sortDirection, size, page }),
    [search, projectSort, sortDirection, size, page]
  )
}
